import { render, staticRenderFns } from "./ContactDeleteDialog.vue?vue&type=template&id=4749d104&"
import script from "./ContactDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports